import React, { Component } from 'react'
import './HistorialCorrectivosAsis.css';
import { getmtoscorrectivos, clearErrors, deleteMtoCorrectivo } from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaFilePdf, FaArrowLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';

import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Tooltip,
  Typography,
  Grid
} from '@mui/material';
import PhotoIcon from '@mui/icons-material/Photo';
import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';

export class HistorialCorrectivosAsis extends Component {

  constructor(){
    super();
    this.state={
    
      mtoid: '',

      
      opensee: false,
      imageUrl: null,
      

    };
    
};

    componentDidMount(){
        this.props.getmtoscorrectivos(this.props.equipoId);
       }

       
       handleOpenSee = (rawdatamtoid, rawimageurl) => {
        this.setState({ opensee: true, mtoid: rawdatamtoid, imageUrl: rawimageurl });
    
      };
    
      handleCloseSee = () => {
        // this.props.clearErrors();
        this.setState({ opensee: false, errors: {}, imageUrl:null });
      };
    
               
       
         
    
    render() {


        const {mtoscorrectivos,loadingmto,equipo}= this.props.data; 
        
     
        const columns = [
           {
            field: 'acciones',
            headerName: 'Acciones',
            width: 130,
            sortable: false,
            renderCell: (params) => (
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Tooltip title="Ver Reporte PDF">
                  <IconButton
                    size="small"
                    component={Link}
                    to={`/dashboard/perfilcliente/equipo/hojadevidapdf/reportepdfcorr/${equipo.credentials.idprestador}/${this.props.equipoId}/${params.row.mtoid}`}
                  >
                    <FaFilePdf color="#03178C" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Ver evidencia cargada">
                  <IconButton
                    size="small"
                    onClick={() => this.handleOpenSee(params.row.mtoid, params.row.imageUrl)}
                  >
                    <PhotoIcon sx={{ color: '#03178C' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            )
          },
          { field: 'fecha', headerName: 'Fecha', width: 120 },
          { field: 'horainicio', headerName: 'Hora Inicio', width: 120 },
          { field: 'horafinal', headerName: 'Hora Final', width: 120 },
         
        ];


        
  const mapeomtoscorrectivos = !loadingmto ? (
          <Box
            sx={{
              height: 500,
              width: '100%',
              mt: 2,
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: 'primary.main',
                color: 'white'
              }
            }}
          >
              <DataGrid
                rows={
                  Array.isArray(mtoscorrectivos)
                    ? mtoscorrectivos.slice().sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
                    : []
                }
                columns={columns}
                getRowId={(row) => row.mtoid}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                components={{
                  Toolbar: () => (
                    <Box p={1}>
                      <GridToolbarQuickFilter placeholder="Buscar..." />
                    </Box>
                  )
                }}
              />
            </Box>
          ) : (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress size={50} color="primary" className="login-progress" />
            </Box>
          );
            
          return (
          <div className="listamtoprog-container">
            <div className="listamtoprog-table">
              <Typography sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600, textAlign: 'center', mb: 1 }}>
                Mantenimientos Correctivos Realizados
              </Typography>
              {mapeomtoscorrectivos}
            </div>

            <Dialog open={this.state.opensee} onClose={this.handleCloseSee} fullWidth maxWidth="sm">
              <DialogTitle>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                  Evidencia Cargada del Mto
                </Typography>
              </DialogTitle>
              <DialogContent>
                {this.state.imageUrl ? (
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12}>
                      <Typography>Esta es la evidencia cargada para esta solicitud</Typography>
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="center">
                      <div className='div-image-carga'>
                        <img src={this.state.imageUrl} alt="Selected" style={{ maxWidth: '100%', maxHeight: '400px' }} />
                      </div>
                    </Grid>
                  </Grid>
                ) : (
                  <Typography>No hay evidencia cargada para mostrar</Typography>
                )}
              </DialogContent>
              <DialogActions>
                <Tooltip title="Cerrar">
                  <IconButton onClick={this.handleCloseSee} size="small">
                    <FaArrowLeft color="#D3D7DC" />
                  </IconButton>
                </Tooltip>
              </DialogActions>
            </Dialog>
          </div>
        )
    }
}

HistorialCorrectivosAsis.propTypes = {
    
    getmtoscorrectivos: PropTypes.func.isRequired,
    data:PropTypes.object.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired,
    deleteMtoCorrectivo:PropTypes.func.isRequired
  };

const mapActionsToProps={getmtoscorrectivos,clearErrors,deleteMtoCorrectivo};

const mapStateToProps = (state)=>({
    data:state.data,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(HistorialCorrectivosAsis);